import { useEffect, useState } from "react";

const TOTAL_FRAMES = 4;
const FRAME_RATE = 210; // Roughly ~10fps

export default function LightRaysAnimation() {
    const [frameIndex, setFrameIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setFrameIndex((prev) => (prev + 1) % TOTAL_FRAMES);
        }, FRAME_RATE);

        return () => clearInterval(interval);
    }, []);

    const framePath = `/images/victoryScreen/light-rays-trnsp${frameIndex + 1}.webp`;

    return (
        <img
            src={framePath}
            alt={`Light Ray Frame ${frameIndex + 1}`}
            className="light-ray-frame"
        />
    );
}
